import { useLazyQuery } from "@apollo/client";
import { GET_PRESCRIPTION } from "./prescription.query";
import { IPrescriptionList } from "./prescription.interface";


export const usePrescription = ()=>{
  const [getPrescription, { data, loading }] =
  useLazyQuery<{getPrescriptions:IPrescriptionList}>(GET_PRESCRIPTION, {
    fetchPolicy: "cache-and-network",
  });


  const getPrescriptionInfo = (id: string)=>{
    getPrescription({
      variables: { id },
    });
  };


  return {
    loading,
    getPrescriptionInfo,
    prescription: data?.getPrescriptions,
  };
};


